export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const toAbsoluteResourceUrl =  (pathname: string) => process.env.REACT_APP_STORAGE_RESOURCE + '/' + process.env.REACT_APP_STORAGE_ACCOUNT + pathname
